<div class="lum-input__wrapper">
  <input
    #lumInput
    [ngClass]="classes"
    [type]="type"
    [required]="required"
    [disabled]="disabled"
    [readonly]="readonly"
    [placeholder]="placeholder"
    [value]="value"
    [min]="min"
    [max]="max"
    [lumDecimalLimit]="allowDecimal"
    (input)="onInputChange($event)"
  />
  <div *ngIf="hintMessage !== null" [ngClass]="['lum-input__hint', hintColor]">
    <small>{{ hintMessage }}</small>
  </div>
</div>
